import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-slate-50 grid place-items-center px-6">
      <div className="max-w-sm w-full bg-white rounded-3xl border border-slate-100 shadow-sm p-8 text-center" data-testid="payment-cancel">
        <div className="w-16 h-16 rounded-full bg-slate-100 text-slate-400 grid place-items-center mx-auto"><XCircle className="w-9 h-9" /></div>
        <p className="font-display font-bold text-2xl text-slate-900 mt-5">Pagamento annullato</p>
        <p className="text-slate-500 text-sm mt-2">Nessun addebito effettuato. Puoi riprovare quando vuoi.</p>
        <Link to="/dashboard/billing" className="mt-6 w-full inline-flex items-center justify-center bg-blue-500 text-white font-semibold rounded-full py-3">Torna ai piani</Link>
      </div>
    </div>
  );
}
